<nav class="navbar navbar-dark navbar-expand-md bg-white">
  <div class="flex col-12 align-items-end">
    <div class="left-menu col-5">
      <ul class="list-horizontal dark-blue float-start">
         <ng-container *ngIf="routePath.startsWith('/flights')">
           <li routerLink="flights/all" routerLinkActive="active">All Flights</li>
           <li routerLink="flights" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Day of Operation</li>
         </ng-container>
         <ng-container *ngIf="routePath === '/alerts'" >
           <li class="active">Alerts</li>
         </ng-container>
         <ng-container *ngIf="routePath === '/chat'">
           <li class="active">Chat</li>
         </ng-container>
        <ng-container *ngIf="routePath.startsWith('/create-message')">
          <li routerLink="create-message" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">ASM Creation</li>
          <li routerLink="create-message/mvt" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">MVT Creation</li>
          <li routerLink="create-message/list" routerLinkActive="active">List of Messages</li>
        </ng-container>
        <ng-container *ngIf="routePath.startsWith('/settings')">
          <li class="active">Settings</li>
        </ng-container>
         <ng-container *ngIf="routePath.startsWith('/reports')">
           <li routerLink="reports" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Cockpit</li>
           <li routerLink="reports/list" routerLinkActive="active">List</li>
         </ng-container>
       </ul>
    </div>
    <div class="col-2 text-center">
      <div class="zulu-time dark-blue" [ngClass]="{'me-0': routePath.startsWith('/flights') }">
        <div ngbDropdown [placement]="['bottom-start', 'top-start', 'bottom-end', 'top-end']" class="d-inline-block">
          <button class="btn btn-outline-primary dropdown dropdown-toggle time dark-blue" id="dropdownBasic1" ngbDropdownToggle>
            {{time | date:'HH:mm':(timezone === 'zulu') ? '+0000' : null}}{{(timezone === 'zulu') ? 'z' : 'L'}}
          </button>
          <div class="zone-dropdown" ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="changeToZulu()"><i class="demo-icon icon-icons8-checkmark"
                                                                [ngClass]="{'hidden' : timezone !== 'zulu'}"></i> UTC time
            </button>
            <button ngbDropdownItem (click)="changeToLocal()"><i class="demo-icon icon-icons8-checkmark"
                                                                 [ngClass]="{'hidden' : timezone !== 'local'}"></i> Local
                                                                                                                    time
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-collapse collapse flex-right col-5" id="navbarResponsive"
         [ngbCollapse]="isNavbarCollapsed" [ngSwitch]="true">
      <ul class="navbar-nav ms-auto float-end">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user?.username === 'admin1'">
          <a class="nav-link" routerLink="/dummies" (click)="collapseNavbar()">
            <div class="nav-icon-container">
              <i class="demo-icon colorWhite size-30"></i>
            </div>
          </a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" routerLink="/flights" (click)="collapseNavbar()" routerLinkActive="active-link">
            <div class="nav-icon-container">
              <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="blue-icon">
                <path d="m49.697-1.582c-2.6521 0.34078-4.4862 2.5995-5.8524 4.7018-1.6774 2.6929-3.0333 5.6219-3.8214 8.7005-0.39984 1.4955-0.31936 3.0406-0.2959 4.5679-0.06785 5.8155-0.17597 11.632-0.10059 17.448-11.527 6.5684-23.31 12.684-34.749 19.408-2.2701 1.4795-4.5217 3.3141-5.6224 5.8574-0.47023 1.6116-0.15428 3.3176-0.24623 4.9715-0.007141 1.739-0.18984 3.6546 0.94126 5.127 1.3458 2.0094 4.1722 2.4353 6.2907 1.5101 11.18-3.4757 22.36-6.9513 33.539-10.427 0.28516 6.6413 0.57031 13.283 0.85547 19.924-3.8143 3.504-7.6804 6.9582-11.462 10.493-1.2044 1.402-1.7148 3.2305-1.8592 5.0426-0.30981 2.0454 0.52611 4.3426 2.4446 5.3098 1.9076 1.0451 4.1685 0.43402 6.005-0.45604 4.7648-2.0285 9.4979-4.1301 14.235-6.2217 5.2709 2.3047 10.505 4.7007 15.835 6.8656 2.072 0.79852 4.7204 0.31424 6.0067-1.6058 1.3691-1.9819 0.96063-4.63 0.13168-6.742-0.56128-1.5946-1.8526-2.7126-3.0728-3.805-3.1798-2.957-6.3596-5.914-9.5393-8.871 0.28516-6.6445 0.57031-13.289 0.85547-19.934 11.58 3.5909 23.155 7.2174 34.739 10.787 2.1603 0.48733 4.6381-0.53377 5.5327-2.6265 0.82919-1.7517 0.39272-3.7336 0.50195-5.5977-0.0224-1.6319 0.23146-3.4201-0.7934-4.83-1.5286-2.6196-3.9703-4.6449-6.7675-5.7866l-33.058-18.403c0.10127-6.2329-0.088572-12.469-0.082678-18.7 0.11914-2.2201-0.44831-4.437-1.4773-6.397-1.4493-3.0523-2.7034-6.3396-5.1262-8.7781-1.0548-1.0154-2.4959-1.7097-3.9876-1.5335zm0.56055 9.1602c1.4202 2.1584 2.9102 4.5047 3.0078 7.1621-0.09892 2.5541 0.04653 5.1182 0.03608 7.6763 0.0295 4.2552 0.1343 8.5228-0.0429 12.769 0.11856 2.1228 1.6811 3.8669 3.5515 4.721 11.294 6.276 22.571 12.585 33.876 18.84 1.314 0.48292 2.5296 1.3253 3.2608 2.5401v2.1074c-12.068-3.7422-24.126-7.522-36.201-11.241-1.6615-0.48487-3.6584 0.37894-4.148 2.1067-0.41581 1.5398-0.22665 3.1688-0.37424 4.7462-0.30971 7.5463-0.67765 15.097-0.95098 22.64 0.17118 1.3761 0.90638 2.6477 2.0267 3.4702 2.4807 2.244 4.9614 4.4881 7.4421 6.7321-3.7066-1.595-7.3702-3.2892-11.097-4.8637-1.3096-0.40001-2.4432 0.59867-3.6209 1.0011-2.9364 1.2969-5.8331 2.5854-8.7667 3.8626 2.7911-2.5445 5.6261-5.05 8.3898-7.6188 0.85881-1.0887 1.2448-2.5061 1.0452-3.8809-0.3742-8.3784-0.68926-16.763-1.1004-25.137-0.1936-1.6728-1.5882-3.238-3.356-3.1735-1.5688 0.07657-3.0114 0.81917-4.5199 1.1993-10.888 3.3854-21.776 6.7708-32.664 10.156 0.069104-0.70749-0.13604-1.5016 0.097669-2.1572 0.77096-1.199 1.9586-2.0397 3.2765-2.5396 11.587-6.4563 23.192-12.885 34.764-19.366 1.8273-1.1118 2.8606-3.3372 2.5031-5.4453-0.14898-6.284 0.06757-12.573 0.07113-18.857-0.12834-2.2575 1.0676-4.3282 2.1692-6.2155 0.33339-0.54773 0.69423-1.0785 1.0657-1.601 0.08594 0.12174 0.17188 0.24349 0.25781 0.36523z" color="#3964ff" stroke-miterlimit="0" stroke-width="0" style="paint-order:stroke markers fill"/>
              </svg>
            </div>
          </a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" routerLink="/alerts" (click)="collapseNavbar()" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" >
            <div class="nav-icon-container">
              <i class="demo-icon icon-icons8-error size-30 alert-icon avitium-color"></i>
            </div>
          </a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" routerLink="/reports" (click)="collapseNavbar()" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
            <div class="nav-icon-container">
              <i class="demo-icon icon-icons8-bar-chart size-30 avitium-color"></i>
            </div>
          </a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" routerLink="/create-message" (click)="collapseNavbar()" routerLinkActive="active-link">
            <div class="nav-icon-container">
                <svg width="32" height="33" overflow="hidden"  xmlns="http://www.w3.org/2000/svg" class="blue-icon">
                  <g transform="matrix(.41536 0 0 .4125 -247.95 -132)">
                    <g>
                      <path d="m637.4 367.2 1.6 4.9-0.9 0.9-4.9-1.6-0.1-0.1c-1.1-1.1-1.1-2.9 0.1-4s3-1.2 4.2-0.1zm-33.6-22 28.2 28.2 11 3.6-3.6-10.9-28.2-28.3z"/>
                      <path d="m597.5 335.9c-0.8 0.9-0.7 2.3 0.2 3.1l4 4 7.3-7.3-4-4c-0.9-0.9-2.4-0.9-3.2 0l-4.1 4.1c-0.1 0-0.1 0.1-0.2 0.1z"/>
                      <path d="m662 373h-17.2l1.4 4h15.8z"/>
                      <path d="m662 349h-35.4l4 4h31.4z"/>
                      <path d="m612 357.6v38.4c0 2.2 1.8 4 4 4h54c2.2 0 4-1.8 4-4v-66c0-2.2-1.8-4-4-4h-17v-2c0-2.2-1.8-4-4-4h-12c-2.2 0-4 1.8-4 4v2h-17c-2.2 0-4 1.8-4 4v4.4l6 6v-8.4h11v6h28v-6h11v62h-50v-30.4zm34-30.6c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3c0.8 0 1.6 0.3 2.1 0.9 0.6 0.5 0.9 1.3 0.9 2.1z"/>
                      <path d="m662 361h-23.4l4 4h19.4z"/>
                    </g>
                  </g>
                </svg>
            </div>
          </a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" routerLink="/settings" (click)="collapseNavbar()" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: false}">
            <div class="nav-icon-container">
              <i class="demo-icon icon-icons8-settings size-30 avitium-color"></i>
            </div>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/chat" (click)="collapseNavbar()" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: false}">
            <div class="nav-icon-container">
              <!--            <app-indicator-dot></app-indicator-dot>-->
              <app-indicator-text *ngIf="unreadMessageCount > 0" [text]="unreadMessageCount?.toString()" size40="true" marginLeft="0" marginTop="0"></app-indicator-text>
              <i class="demo-icon icon-icons8-new-post size-30 avitium-color"></i>
            </div>
          </a>
        </li>
        <li class="nav-item d-inline-block align-self-center" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            ngbDropdown display="dynamic" placement="bottom-right" (openChange)="userCardOpen = $event">
          <!--
                  <div class="item-header-container rounded-circle" id="dropdownUser" ngbDropdownToggle>
                    <i class="demo-icon rounded-circle item-header">{{usersInitials}}</i>
                  </div> -->
          <!--
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()" id="dropdownUser" ngbDropdownToggle>
            <img src="./content/images/avatar.png" class="rounded-circle avatar">
          </a> -->

          <a class="nav-link avatarIcon pb-0" (click)="collapseNavbar()" id="dropdownUser" ngbDropdownToggle #dropdownLink>
            <svg class="bi bi-person" width="35px" height="35px" viewBox="0 0 16 16" [attr.fill]="userCardOpen ? 'var(--avitium-orange)' : 'var(--avitium-blue)'"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM8 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0z" clip-rule="evenodd"/>
            </svg>
          </a>

          <div class="profile-card text-center" ngbDropdownMenu="ngbDropdownMenu" aria-labelledby="dropdownUser">
            <div class="flex">
              <div class="col-2"></div>
              <div class="flex col-8 justify-content-center">
                <div>Account</div>
              </div>
              <div class="col-2"></div>
            </div>
            <hr>
            <div class="user-info flex flex-row" style="">
              <div class="col-2 flex">
                <app-user-photo class="align-self-center m-auto" [size]="50" [user]="user" circleBackground="#F2F2F2" textColor="black"></app-user-photo>
              </div>
              <div class="flex flex-column col-8 justify-content-center">
                <div class="flex flex-column" style="align-self:center;">
                  <div class="user-name fw-normal">{{user.firstname}} {{user.lastname}} ({{user.location}})</div>
                  <div class="text-muted">{{user.role | i18nSelect: userRoleObject.DISPLAY_TITLE_MAP }}</div>
                </div>
                <div class="user-role ps-2">{{ user.email }}</div>
              </div>
              <div class="col-2"></div>
            </div>
            <hr>
            <div (click)="logout()" class="ps-3 profile-card-button"><fa-icon [icon]="logoutIcon"></fa-icon> Log Out</div>
            <!-- <div class="row text-center flex justify-content-center mt-2">
              <button class="btn btn-outline-danger w-50" (click)="logout()">Logout</button>
            </div> -->

          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
